module.exports = __webpack_public_path__ + "img/activity_detial_bg.a6871714.png";